import React, { useState } from "react";
import styles from "./style/answer_profile.module.css";
import styles_mm from "./style/answer_matrix.module.css";
import { useLanguage } from '../../functions/setGetLanguage';

import ImgBuilder from "../../assets/ImgBuilder";
import DotsCarrousel from '../dotsCarrousel/dotsCarrousel';

const Answer_profile = ({ choices_cr, choices, FunctionOnClick, carrousel, setCarrousel, variables, minSwipeDistance}) => {
  const { language } = useLanguage();

  const handleChoiceClick = (choice) => {
    // If the choice has a next property, update the carousel index
    if (choice.carrousel_action === true){
      if (choice.hasOwnProperty('store_variable')){
        const storeKey = Object.keys(choice.store_variable)[0];
        const newProfile = 
        {
          [storeKey]: choices_cr[carrousel]?.asset_add ? 
                              choices_cr[carrousel]?.asset_add : 
                              choices_cr[carrousel].name
        };
        setCarrousel(0);
        choice.store_variable = newProfile
        FunctionOnClick(choice);
      }
      else{
        const current_choice = choices_cr[carrousel]
        setCarrousel(0);
        FunctionOnClick(current_choice);
      }
    }
    else{
      const newIndex = (carrousel + 1) % choices_cr.length;
      setCarrousel(newIndex);
      return
    }
  };

  // swipe
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = (item) => {
    setTouchEnd(null);
    setTouchStart(item.targetTouches[0].clientX);
  };

  const handleTouchMove = (item) => {
    setTouchEnd(item.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (typeof touchStart !== "number" || typeof touchEnd !== "number") return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance){ 
      const newIndex = (carrousel + 1) % choices_cr.length;
      setCarrousel(newIndex);
    }
    else if (distance < -minSwipeDistance) {
      const newIndex = (carrousel - 1 + choices_cr.length) % choices_cr.length;
      setCarrousel(newIndex);
    };
  };

  return (
    <>
      <div 
        className={styles.center}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className={styles.carrousel_outer}>
          <div className={styles.carrousel}>
              {choices_cr.map((choice, i) => (
                <div key={i} className={`${styles.carrousel_inner_con} ${carrousel === i ? styles.activeClass : ''}`}>
                  <img
                    src={ImgBuilder[choice?.asset_add ? choice.asset_add : choice.name]}
                    alt={`${choice.name}_profile`}
                    className={styles.image}
                  />
                  <p className={styles.name}>
                    {choice.name}
                  </p>
                  <p className={styles.slogan}>{choice[`text${language}`]}</p>
                </div>
              ))}
          </div>
        </div>
        <DotsCarrousel choices={choices_cr} carrousel={carrousel}/>
      </div>

      <div className={styles_mm.choices}>
        {choices.map((choice, i) => (
          <button
            key={i}
            className={styles_mm.choiceButton}
            onClick={() => handleChoiceClick(choice)}
          >
            {choice[`text${language}`]}
          </button>
        ))}
      </div>
    </>
  );
};

export default Answer_profile;
